import { render, staticRenderFns } from "./manageNotification.vue?vue&type=template&id=4f7d89c4&scoped=true&"
import script from "./manageNotification.vue?vue&type=script&lang=js&"
export * from "./manageNotification.vue?vue&type=script&lang=js&"
import style0 from "./manageNotification.vue?vue&type=style&index=0&id=4f7d89c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7d89c4",
  null
  
)

export default component.exports